import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';

export function DealerInfo({ dealerInfo, distance = 0, showRating = true, className }) {
  // TODO, it would be nice to have generic structure of dealer and inventory.dealerInfo
  const salesOverallRating = get(dealerInfo, 'displayInfo.salesOverallRating', get(dealerInfo, 'salesRating', 0));
  const salesReviewCount = get(dealerInfo, 'displayInfo.salesReviewCount', get(dealerInfo, 'salesReviewCount', 0));

  return (
    <div className={className}>
      {showRating && (
        <div className="small">
          <RatingStars rating={salesOverallRating} className="text-primary-darker me-0_25" />
          <span>({salesReviewCount})</span>
        </div>
      )}
      <div className="text-gray-darker">{dealerInfo.name}</div>
      {distance > 0 && <div className="small text-gray-dark">{distance.toFixed(1)} miles away</div>}
    </div>
  );
}

DealerInfo.propTypes = {
  dealerInfo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayInfo: PropTypes.shape({
      salesOverallRating: PropTypes.number,
      salesReviewCount: PropTypes.number,
    }),
    salesRating: PropTypes.number,
    salesReviewCount: PropTypes.number,
  }).isRequired,
  distance: PropTypes.number,
  showRating: PropTypes.bool,
  className: PropTypes.string,
};
